module.exports = __webpack_public_path__ + "static/media/icon-where.c5f78dda.png";